import React from "react";

import OrderDateCellContent from "../components/OrderDateCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function orderDate({ width, onResize }: Column.Options) {
	return base(
		ColumnId.OrderDate,
		(item) => <OrderDateCellContent item={item} />,
		{
			width,
			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default orderDate;
